export { matchers } from './client-matchers.js';

export const components = [
	() => import("../../src/routes/__layout.svelte"),
	() => import("../runtime/components/error.svelte"),
	() => import("../../src/routes/glyphs/index.svelte"),
	() => import("../../src/routes/index.svelte"),
	() => import("../../src/routes/me/index.svelte")
];

export const dictionary = {
	"": [[0, 3], [1]],
	"glyphs": [[0, 2], [1]],
	"me": [[0, 4], [1]]
};